/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { StaticIntegration } from 'cio/utils/integrations/static-integrations';
import AccountService from 'cio/services/account';
import { bool } from '@ember/object/computed';

interface IntegrationsFeaturedGroupArgs {
  members: string[];
  onClick: () => unknown;
  title: string;
  integrations: StaticIntegration[];
  isPremium?: boolean;
}

export default class IntegrationsFeaturedGroup extends Component<IntegrationsFeaturedGroupArgs> {
  @service account!: AccountService;

  @bool('account.current.suspendTrialAt') isEssentialsTrial!: boolean;

  get isDataWarehouseSyncAvailable() {
    return this.account.planFeatures.warehouseSync.enabled;
  }

  get isFeatureGated() {
    return this.args.isPremium === true && !this.isDataWarehouseSyncAvailable;
  }

  get integrations() {
    return this.args.members.map((member: string) => this.args.integrations.findBy('id', member));
  }

  get integrationIcons() {
    return this.integrations.slice(0, 3);
  }

  @action
  handleClick(popoverOpen: () => unknown) {
    if (this.isFeatureGated) {
      popoverOpen();
    } else {
      this.args.onClick();
    }
  }
}
